import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "50%",

  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BatchDeliverModal({ openDialog, handleOnCloseClicked, title, content, handleOnSendClicked }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [code, setCode] = React.useState(false);

  React.useEffect(() => {
    setOpen(openDialog);
  }, [openDialog]);

  const onCloseClicked = () => {
    handleClose();
    handleOnCloseClicked();
  }

  const onSendClicked = () => {
    handleOnSendClicked();
  }

  return (
    <div>
      <Modal
        open={open}
        onClose={onCloseClicked}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="flex">
          <Typography id="modal-modal-title" variant="h6" component="h2"  className="">
            DRCに発送しますか
            {title}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 8 }} align="center" className="">
            {content}
          </Typography>
          <div className="w-full h-16 lg:h-12 pl-20 lg:pl-0 flex items-center justify-end place-content-end absolute inset-x-0 top-2/3 ">
            <button
              onClick={onSendClicked}
              type="button"
              className={`w-auto h-8 flex items-center justify-center gap-2 px-4 rounded text-white bg-[#666FC8] mr-4 lg:mr-6`} 
            >
              一括発送
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}